import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const ClosedModal = ({ isOpen, onClose, apartmentName, closedDate, isOpeningSoon = false }) => {
  // 애니메이션 설정
  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
  };

  const contentVariants = {
    hidden: {
      scale: 0.8,
      opacity: 0,
      transition: {
        type: "spring",
        damping: 30,
        stiffness: 300,
      },
    },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 25,
        stiffness: 300,
      },
    },
    exit: {
      scale: 0.8,
      opacity: 0,
      transition: {
        type: "spring",
        damping: 35,
        stiffness: 300,
      },
    },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="closed-modal-overlay"
          initial="hidden"
          animate="visible"
          exit="hidden"
          variants={overlayVariants}
          transition={{ duration: 0.25 }}
          onClick={onClose}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
        >
          <motion.div
            className="closed-modal-content"
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={contentVariants}
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "16px",
              padding: "32px 24px",
              maxWidth: "320px",
              width: "100%",
              textAlign: "center",
              boxShadow:
                "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
            }}
          >
            {/* 경고 아이콘 */}
            {/* <div
              style={{
                width: "64px",
                height: "64px",
                backgroundColor: "#FEF3C7",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 24px auto",
              }}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="#F59E0B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div> */}

            {/* 메시지 */}
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#1F2937",
                margin: "0 0 12px 0",
                lineHeight: "1.4",
              }}
            >
              {isOpeningSoon ? "접수 안내" : "접수 마감 안내"}
            </h3>

            <p
              style={{
                fontSize: "16px",
                fontWeight: "400",
                color: "#6B7280",
                margin: "0 0 24px 0",
                lineHeight: "1.5",
              }}
            >
              {apartmentName}
              {apartmentName === "포레온스테이션5" ? "" : " 아파트"}
              의
              <br />
              채권양도·양수 접수는
              <br />
              {isOpeningSoon ? (
                <>
                  <strong style={{ color: "#1F2937" }}>
                    {closedDate}부터 시작
                  </strong>
                  됩니다.
                </>
              ) : (
                <>
                  <strong style={{ color: "#1F2937" }}>
                    {closedDate}부로 마감
                  </strong>
                  되었습니다.
                </>
              )}
            </p>

            {/* 확인 버튼 */}
            <button
              onClick={onClose}
              style={{
                width: "100%",
                height: "48px",
                backgroundColor: "#7B42F6",
                color: "#FFFFFF",
                border: "none",
                borderRadius: "12px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#6A35E5";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#7B42F6";
              }}
            >
              확인
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ClosedModal;
